var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoldArrowDivider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 16,
    viewBox: "0 0 284 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.1114 5.95898L32.5784 8.00135L38.1114 10.0415L43.6445 8.00135L38.1114 5.95898Z",
    fill: "#A08B62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M160.663 7.70215H19.8459V8.30024H160.663V7.70215Z",
    fill: "#A08B62"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2277 8.00092C8.90797 10.2116 5.97017 9.15944 0 8.00092C5.97227 6.8424 8.90797 5.7902 10.2277 8.00092Z",
    fill: "#A08B62"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0678 7.8239C24.0678 7.8239 12.823 11.0248 9.87262 5.5135L6.92432 0C6.92432 0 11.3478 6.93341 24.0678 7.8239Z",
    fill: "#A08B62"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0677 8.17628C24.0677 8.17628 12.8229 4.97539 9.87253 10.4867L6.92212 15.998C6.92212 15.998 11.3456 9.06455 24.0656 8.17406L24.0677 8.17628Z",
    fill: "#A08B62"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9065 8.00116C25.9065 8.71444 25.0827 9.29481 24.0678 9.29481C23.0528 9.29481 22.229 8.71666 22.229 8.00116C22.229 7.28567 23.0528 6.70752 24.0678 6.70752C25.0827 6.70752 25.9065 7.28567 25.9065 8.00116Z",
    fill: "#A08B62"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5461 8.0012C29.5461 8.41764 29.0669 8.75435 28.4743 8.75435C27.8817 8.75435 27.4026 8.41764 27.4026 8.0012C27.4026 7.58475 27.8817 7.24805 28.4743 7.24805C29.0669 7.24805 29.5461 7.58475 29.5461 8.0012Z",
    fill: "#A08B62"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M245.889 10.0415L251.42 8.00135L245.889 5.95898L240.355 8.00135L245.889 10.0415Z",
    fill: "#A08B62"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M264.152 7.70215H123.335V8.30024H264.152V7.70215Z",
    fill: "#A08B62"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M273.77 8.00141C275.09 5.79069 278.028 6.84289 283.998 8.00141C278.026 9.15993 275.09 10.2121 273.77 8.00141Z",
    fill: "#A08B62"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M259.932 8.17628C259.932 8.17628 271.177 4.97539 274.128 10.4867L277.078 15.998C277.078 15.998 272.654 9.06455 259.934 8.17406L259.932 8.17628Z",
    fill: "#A08B62"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M259.932 7.82412C259.932 7.82412 271.177 11.025 274.128 5.51372L277.078 0.00244141C277.078 0.00244141 272.654 6.93585 259.934 7.82634L259.932 7.82412Z",
    fill: "#A08B62"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M258.094 8.00116C258.094 7.28789 258.918 6.70752 259.933 6.70752C260.947 6.70752 261.771 7.28567 261.771 8.00116C261.771 8.71666 260.947 9.29481 259.933 9.29481C258.918 9.29481 258.094 8.71666 258.094 8.00116Z",
    fill: "#A08B62"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M254.454 8.0012C254.454 7.58475 254.933 7.24805 255.526 7.24805C256.118 7.24805 256.598 7.58475 256.598 8.0012C256.598 8.41764 256.118 8.75435 255.526 8.75435C254.933 8.75435 254.454 8.41764 254.454 8.0012Z",
    fill: "#A08B62"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M138.029 8.00088L142 13.0403L145.97 8.00088L142 2.96143L138.029 8.00088Z",
    fill: "#A08B62"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M142 5.20996L134.828 8.00104L142 10.7899L149.172 8.00104L142 5.20996Z",
    fill: "#A08B62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldArrowDivider);
export default __webpack_public_path__ + "static/media/gold-arrow-divider.8aa486e53764e394d731cc0009f7bc88.svg";
export { ForwardRef as ReactComponent };